import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {

  [types.SET_CATS_PAGE](state, { catPage }) {
    Vue.set(state.catPages, catPage.id, catPage);
  },

  [types.SET_CATS_PAGE_ID](state, { catPageId, catPageIdIndex }) {
    Vue.set(state.catPageIdList, catPageIdIndex, catPageId);
  },

  [types.SET_PAGINATION](state, pagination) {
    Vue.set(state, 'pagination', pagination);
  },

  [types.SELECT_OPTIONS](state, selectedOption) {
    Vue.set(state, 'selectedOptions', selectedOption);
  },

  [types.RESELECT_OPTIONS](state) {
    Vue.set(state, 'selectedOptions', {});
  },

  [types.SET_PAGES_TOTAL](state, totalValue) {
    Vue.set(state.pagination, 'total', totalValue);
  },

  [types.RESET_QUIZ_START_TIME](state) {
    Vue.set(state, 'startTime', new Date());
  },

  [types.SET_MONITORING_HISTORIES](state, histories) {
    Vue.set(state, 'monitoringHistories', histories);
  },

  [types.SET_PAGE_QUIZ_RESULT_CACHE](state, pageQuizResultCache) {
    Vue.set(state, 'pageQuizResultCache', pageQuizResultCache);
  },

  [types.SET_PAGE_ANSWER_STATISTICS](state, pageAnswerStatistics) {
    Vue.set(state, 'pageAnswerStatistics', pageAnswerStatistics);
  },

  [types.SET_USER_QUESTIONS](state, useQuestions) {
    Vue.set(state, 'useQuestions', useQuestions);
  },
};

export default mutations;
